import { styled } from "@mui/material/styles";
import { Box, FormControl } from "@mui/material";

export const StyledFormControl = styled(FormControl)(
  ({ theme, error, fullWidth, disabled }) => ({
    marginBottom: theme.spacing(2),
    width: fullWidth ? "100%" : "auto",
    borderColor: error ? theme.palette.error.main : theme.palette.divider,
    pointerEvents: disabled ? "none" : "auto",
  })
);

export const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "error",
})<{ error?: boolean }>(({ theme, error }) => ({
  display: "flex",
  alignItems: "center",
  fontSize: theme.typography.body1.fontSize,
  lineHeight: theme.typography.body1.lineHeight,
  color: theme.palette.text.primary,
  border: `1px solid ${
    error ? theme.palette.error.main : theme.palette.divider
  }`,
  borderRadius: theme.shape.borderRadius,
  flexGrow: 1,
  marginRight: theme.spacing(1),
  position: "relative",
  backgroundColor: "#fcf8f4",
  "&:hover": {
    borderColor: theme.palette.text.primary,
  },
  "&.Mui-disabled": {
    backgroundColor: theme.palette.action.disabledBackground,
    borderColor: theme.palette.action.disabled,
    cursor: "default",
  },
  "&.Mui-static-field": {
    pointerEvents: "none",
    input: {
      backgroundColor: "#f8f8f8",
      WebkitTextFillColor: theme.palette.text.secondary,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "0",
    },
  },
}));
